export interface IWorkOrderListItemEmployee {
    id: string;
    name: string;
}

export class WorkOrderListItemEmployee implements IWorkOrderListItemEmployee {
    id: string;
    name: string;

    constructor();
    constructor(obj: IWorkOrderListItemEmployee);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.name = obj && obj.name || "";
    }
}